module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.3.5-233.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.3.5.md
// module id = 676
// module chunks = 302